// *** FIREBASE SERVICE ***

import firebase from 'firebase';

// *** GET FIREBASE AUTH USER ID TOKEN ***
export const getIdToken = async () => {
    return await firebase.auth().currentUser.getIdToken(true);
};

// *** SIGN IN FIREBASE AUTH USER ***
export const signIn = async (email, password) => {
    await firebase.auth().signInWithEmailAndPassword(email, password);
};

// *** SIGN OUT FIREBASE AUTH USER ***
export const signOut = async () => {
    await firebase.auth().signOut();
};
